const ProjectType = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <rect
        x="1"
        y="1"
        width="10"
        height="10"
        rx="1.5"
        stroke="var(--tx2)"
        strokeWidth="1"
      />
      <line x1="3" y1="4" x2="9" y2="4" stroke="var(--tx2)" strokeWidth="1" />
    </svg>
  );
};

export default ProjectType;
